import React from "react";
import useFavourites from "@icarius-common/favouriteButton/components/useFavourites";
import Loader from "@icarius-common/loader";
import GroupSelector from "./groupSelector";
import GridScreen from "./gridScreen";
import useGeoanalysis from "./useGeoanalysis";

const Geoanalysis = () => {

  const {
    state,
    handlers,
    isLoading,
    groups,
    queries,
    isFromHiddenGroup,
  } = useGeoanalysis();

  const {
    isLoadingFavourites,
    favouriteList,
    handleChangeFavourite,
  } = useFavourites('GEO');


  return (
    <section id={"my-people-page"}>
      <Loader open={isLoading || isLoadingFavourites} />
      {
        state.gridIsOpen
          ?
          <GridScreen
            title={state.groupName}
            queryPreset={state.queryPreset}
            userPreset={state.userPreset}
            queries={queries}
            favouriteList={favouriteList}
            isFromHiddenGroup={isFromHiddenGroup}
            handleChangeFavourite={handleChangeFavourite}
            handleCloseGrid={handlers.handleCloseGrid}
          />
          :
          !isLoading &&
          <GroupSelector
            groups={groups}
            handleClick={handlers.handleOpenGrid}
          />
      }
    </section>
  );
}

export default Geoanalysis;
